/*
 * Store locator (sections/store-locator.liquid).
 *
 * Search rules, in order:
 *   1. 5-digit ZIP          -> geocoded (zippopotam.us), stores within the radius
 *   2. state code or name   -> every store in that state, by city
 *   3. a city in the list   -> stores within the radius of that city's stores
 *   4. anything else        -> text match on store name, street and city; if
 *                              nothing matches on submit, the text is geocoded
 *                              (OpenStreetMap Nominatim) and treated as a place
 * "Use my location" sorts by distance from the browser's position.
 * The map is a keyless Google Maps embed pointed at the selected store.
 */
(function () {
  var PAGE_SIZE = 25;
  // Same pin as the Contact page's "Our Locations" list.
  var PIN = '<svg class="store-locator__pin" aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 4.68 6 11 7 12 1-1 7-7.32 7-12 0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5S10.62 6.5 12 6.5s2.5 1.12 2.5 2.5S13.38 11.5 12 11.5z"/></svg>';
  var EARTH_RADIUS_MI = 3958.8;
  // The distillery, used for the initial "within 25 mi" view (same default as
  // the old tcwhiskey.com/whiskey-finder/?radius=25 link).
  var HOME = { lat: 44.75186, lng: -85.62060, label: 'Traverse City, MI' };

  var STATES = {
    AL: 'Alabama', AK: 'Alaska', AZ: 'Arizona', AR: 'Arkansas', CA: 'California', CO: 'Colorado',
    CT: 'Connecticut', DE: 'Delaware', DC: 'District of Columbia', FL: 'Florida', GA: 'Georgia',
    HI: 'Hawaii', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana', IA: 'Iowa', KS: 'Kansas',
    KY: 'Kentucky', LA: 'Louisiana', ME: 'Maine', MD: 'Maryland', MA: 'Massachusetts',
    MI: 'Michigan', MN: 'Minnesota', MS: 'Mississippi', MO: 'Missouri', MT: 'Montana',
    NE: 'Nebraska', NV: 'Nevada', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico',
    NY: 'New York', NC: 'North Carolina', ND: 'North Dakota', OH: 'Ohio', OK: 'Oklahoma',
    OR: 'Oregon', PA: 'Pennsylvania', RI: 'Rhode Island', SC: 'South Carolina',
    SD: 'South Dakota', TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VT: 'Vermont',
    VA: 'Virginia', WA: 'Washington', WV: 'West Virginia', WI: 'Wisconsin', WY: 'Wyoming'
  };

  function norm(text) {
    return String(text || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/['’.]/g, '')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function stateFromText(text) {
    var key = norm(text);
    if (!key) return null;
    var upper = key.toUpperCase();
    if (STATES[upper]) return upper;
    for (var code in STATES) {
      if (norm(STATES[code]) === key) return code;
    }
    return null;
  }

  function distanceMi(aLat, aLng, bLat, bLng) {
    var rad = Math.PI / 180;
    var dLat = (bLat - aLat) * rad;
    var dLng = (bLng - aLng) * rad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(aLat * rad) * Math.cos(bLat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * EARTH_RADIUS_MI * Math.asin(Math.sqrt(h));
  }

  function zoomForRadius(radius) {
    if (radius <= 5) return 13;
    if (radius <= 10) return 12;
    if (radius <= 25) return 10;
    if (radius <= 50) return 9;
    return 8;
  }

  function mapSrc(query, zoom) {
    return 'https://maps.google.com/maps?q=' + encodeURIComponent(query) + '&z=' + zoom + '&output=embed';
  }

  function escapeHtml(text) {
    return String(text).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function Locator(root) {
    this.root = root;
    this.form = root.querySelector('[data-store-locator-form]');
    this.input = root.querySelector('[data-store-locator-query]');
    this.radiusSelect = root.querySelector('[data-store-locator-radius]');
    this.geoButton = root.querySelector('[data-store-locator-geolocate]');
    this.statesEl = root.querySelector('[data-store-locator-states]');
    this.status = root.querySelector('[data-store-locator-status]');
    this.list = root.querySelector('[data-store-locator-list]');
    this.more = root.querySelector('[data-store-locator-more]');
    this.map = root.querySelector('[data-store-locator-map]');
    this.defaultMap = root.dataset.defaultMap || HOME.label;

    this.stores = [];
    this.cities = {};
    this.results = [];
    this.shown = 0;
    this.searchId = 0;
    this.debounce = null;

    this.bind();
    this.load();
  }

  Locator.prototype.bind = function () {
    var self = this;

    this.form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearTimeout(self.debounce);
      self.search(self.input.value, true);
    });

    this.input.addEventListener('input', function () {
      clearTimeout(self.debounce);
      self.debounce = setTimeout(function () {
        self.search(self.input.value, false);
      }, 220);
    });

    this.radiusSelect.addEventListener('change', function () {
      if (self.origin) self.showNear(self.origin);
      self.syncUrl();
    });

    this.geoButton.addEventListener('click', function () {
      self.geolocate();
    });

    this.more.addEventListener('click', function () {
      self.renderMore();
    });

    this.list.addEventListener('click', function (event) {
      if (event.target.closest('a')) return;
      var item = event.target.closest('[data-index]');
      if (item) self.select(Number(item.dataset.index), true);
    });

    this.list.addEventListener('keydown', function (event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      if (event.target.closest('a')) return;
      var item = event.target.closest('[data-index]');
      if (!item) return;
      event.preventDefault();
      self.select(Number(item.dataset.index), true);
    });

    this.statesEl.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-state]');
      if (!chip) return;
      self.input.value = STATES[chip.dataset.state] || chip.dataset.state;
      self.search(self.input.value, true);
    });
  };

  Locator.prototype.load = function () {
    var self = this;
    fetch(this.root.dataset.locationsUrl)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (data) {
        self.stores = data.stores.map(function (row) {
          return {
            name: row[0],
            street: row[1],
            city: row[2],
            state: row[3],
            lat: row[4],
            lng: row[5],
            text: norm(row[0] + ' ' + row[1] + ' ' + row[2])
          };
        });
        self.indexCities();
        self.renderStates();

        var params = new URLSearchParams(window.location.search);
        var radius = params.get('radius');
        if (radius && self.radiusSelect.querySelector('option[value="' + Number(radius) + '"]')) {
          self.radiusSelect.value = String(Number(radius));
        }
        var query = params.get('q') || params.get('addressInput') || '';
        self.input.value = query;
        self.search(query, true);
      })
      .catch(function () {
        self.setStatus('Sorry, the store list could not be loaded. Please refresh the page to try again.');
      });
  };

  Locator.prototype.indexCities = function () {
    var cities = {};
    this.stores.forEach(function (store) {
      var key = norm(store.city);
      (cities[key] = cities[key] || []).push(store);
    });
    this.cities = cities;
  };

  Locator.prototype.renderStates = function () {
    var counts = {};
    this.stores.forEach(function (store) {
      counts[store.state] = (counts[store.state] || 0) + 1;
    });
    var codes = Object.keys(counts).sort(function (a, b) {
      return (STATES[a] || a).localeCompare(STATES[b] || b);
    });
    this.statesEl.innerHTML = 'Browse by state: ' + codes.map(function (code) {
      return '<button type="button" class="store-locator__state" data-state="' + code + '">' +
        escapeHtml(STATES[code] || code) + '</button>';
    }).join(', ');
  };

  Locator.prototype.radius = function () {
    return Number(this.radiusSelect.value) || 25;
  };

  Locator.prototype.setStatus = function (html) {
    this.status.innerHTML = html;
  };

  Locator.prototype.search = function (rawQuery, submitted) {
    var self = this;
    var query = rawQuery.trim();
    var id = ++this.searchId;
    this.syncUrl();
    this.markState(null);

    if (!query) {
      this.showNear(HOME);
      return;
    }

    // ZIP code (allow ZIP+4)
    var zip = query.match(/^(\d{5})(?:-\d{4})?$/);
    if (zip) {
      if (!submitted) return;
      this.setStatus('Looking up ' + escapeHtml(zip[1]) + '…');
      fetch('https://api.zippopotam.us/us/' + zip[1])
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.json();
        })
        .then(function (data) {
          if (id !== self.searchId) return;
          var place = data.places[0];
          self.showNear({
            lat: Number(place.latitude),
            lng: Number(place.longitude),
            label: zip[1] + ' (' + place['place name'] + ', ' + place['state abbreviation'] + ')'
          });
        })
        .catch(function () {
          if (id !== self.searchId) return;
          self.showList([], 'We couldn’t find ZIP code ' + escapeHtml(zip[1]) + '. Try a city name instead.');
        });
      return;
    }

    // A state with no stores falls through to the place lookup below, so the
    // shopper still sees the closest stores.
    var state = stateFromText(query);
    if (state && this.hasState(state)) {
      this.showState(state);
      return;
    }

    // "Traverse City" or "Traverse City, MI"
    var cityParts = query.split(',');
    var cityState = cityParts.length > 1 ? stateFromText(cityParts[cityParts.length - 1]) : null;
    var cityKey = norm(cityState ? cityParts.slice(0, -1).join(',') : query);
    var cityStores = (this.cities[cityKey] || []).filter(function (store) {
      return !cityState || store.state === cityState;
    });
    if (cityStores.length) {
      this.showNear(this.cityCenter(cityStores));
      return;
    }

    var words = norm(query).split(' ');
    var matches = this.stores.filter(function (store) {
      return words.every(function (word) {
        return (' ' + store.text).indexOf(' ' + word) !== -1;
      });
    });

    if (matches.length || !submitted) {
      this.origin = null;
      matches.sort(byCityThenName);
      this.showList(matches, matches.length
        ? matches.length + ' ' + plural(matches.length, 'location') + ' matching “' + escapeHtml(query) + '”'
        : 'No matches for “' + escapeHtml(query) + '”. Press Search to look nearby.');
      return;
    }

    this.searchPlace(query, id);
  };

  // Nothing in the list: treat the text as a place and look for nearby stores.
  Locator.prototype.searchPlace = function (query, id) {
    var self = this;
    this.setStatus('Searching near ' + escapeHtml(query) + '…');
    fetch('https://nominatim.openstreetmap.org/search?format=json&limit=1&countrycodes=us&q=' + encodeURIComponent(query))
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.json();
      })
      .then(function (places) {
        if (id !== self.searchId) return;
        if (!places.length) throw new Error('not found');
        self.showNear({
          lat: Number(places[0].lat),
          lng: Number(places[0].lon),
          label: query
        });
      })
      .catch(function () {
        if (id !== self.searchId) return;
        self.showList([], 'No stores found for “' + escapeHtml(query) + '”. Try a nearby city, a ZIP code or a state.');
      });
  };

  Locator.prototype.hasState = function (code) {
    return this.stores.some(function (store) { return store.state === code; });
  };

  Locator.prototype.cityCenter = function (stores) {
    var lat = 0;
    var lng = 0;
    stores.forEach(function (store) {
      lat += store.lat;
      lng += store.lng;
    });
    var counts = {};
    stores.forEach(function (store) {
      counts[store.state] = (counts[store.state] || 0) + 1;
    });
    var state = Object.keys(counts).sort(function (a, b) { return counts[b] - counts[a]; })[0];
    return { lat: lat / stores.length, lng: lng / stores.length, label: stores[0].city + ', ' + state };
  };

  Locator.prototype.showNear = function (origin) {
    var radius = this.radius();
    this.origin = origin;
    var withDistance = this.stores.map(function (store) {
      return { store: store, distance: distanceMi(origin.lat, origin.lng, store.lat, store.lng) };
    }).sort(function (a, b) { return a.distance - b.distance; });

    var inside = withDistance.filter(function (entry) { return entry.distance <= radius; });
    var label = escapeHtml(origin.label);
    var message;
    if (inside.length) {
      message = inside.length + ' ' + plural(inside.length, 'location') +
        ' within ' + radius + ' miles of ' + label;
    } else {
      inside = withDistance.slice(0, 10);
      message = 'Nothing within ' + radius + ' miles of ' + label + '. These are the closest.';
    }

    this.map.src = mapSrc(origin.lat + ',' + origin.lng, zoomForRadius(radius));
    this.showList(inside.map(function (entry) {
      return Object.assign({ distance: entry.distance }, entry.store);
    }), message, true);
  };

  Locator.prototype.showState = function (code) {
    this.origin = null;
    var name = STATES[code] || code;
    var matches = this.stores.filter(function (store) { return store.state === code; }).sort(byCityThenName);
    this.markState(code);
    this.map.src = mapSrc(name, code === 'MI' ? 6 : 7);
    this.showList(matches, matches.length
      ? matches.length + ' ' + plural(matches.length, 'location') + ' in ' + escapeHtml(name)
      : 'We don’t have any stores listed in ' + escapeHtml(name) + ' yet.', true);
  };

  Locator.prototype.markState = function (code) {
    this.statesEl.querySelectorAll('[data-state]').forEach(function (chip) {
      chip.setAttribute('aria-pressed', chip.dataset.state === code ? 'true' : 'false');
    });
  };

  Locator.prototype.showList = function (results, message, keepMap) {
    this.results = results;
    this.shown = 0;
    this.list.innerHTML = '';
    this.setStatus(message);
    this.renderMore();
    if (!keepMap && results.length) this.select(0, false);
    if (!results.length && !keepMap) this.map.src = mapSrc(this.defaultMap, 11);
  };

  Locator.prototype.renderMore = function () {
    var self = this;
    var next = this.results.slice(this.shown, this.shown + PAGE_SIZE);
    var html = next.map(function (store, offset) {
      var index = self.shown + offset;
      var address = store.street + ', ' + store.city + ', ' + store.state;
      var directions = 'https://www.google.com/maps/dir/?api=1&destination=' +
        encodeURIComponent(store.name + ', ' + address);
      return '<li class="store-locator__item" data-index="' + index + '" tabindex="0" role="button" aria-label="Show ' + escapeHtml(store.name) + ' on the map">' +
        '<div class="store-locator__name">' + PIN + '<span>' + escapeHtml(store.name) + '</span>' +
          (typeof store.distance === 'number'
            ? '<span class="store-locator__distance">' + formatDistance(store.distance) + '</span>'
            : '') +
        '</div>' +
        '<p class="store-locator__address">' + escapeHtml(store.street) + '<br>' +
          escapeHtml(store.city) + ', ' + escapeHtml(store.state) + '</p>' +
        '<a class="store-locator__directions" href="' + directions + '" target="_blank" rel="noopener">Directions</a>' +
      '</li>';
    }).join('');
    this.list.insertAdjacentHTML('beforeend', html);
    this.shown += next.length;
    var remaining = this.results.length - this.shown;
    this.more.hidden = remaining <= 0;
    this.more.textContent = 'Show more';
  };

  Locator.prototype.select = function (index, scrollMap) {
    var store = this.results[index];
    if (!store) return;
    this.list.querySelectorAll('.is-active').forEach(function (el) { el.classList.remove('is-active'); });
    var item = this.list.querySelector('[data-index="' + index + '"]');
    if (item) item.classList.add('is-active');
    this.map.src = mapSrc(store.name + ', ' + store.street + ', ' + store.city + ', ' + store.state, 15);
    if (scrollMap && window.matchMedia('(max-width: 899px)').matches) {
      this.map.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };

  Locator.prototype.geolocate = function () {
    var self = this;
    if (!navigator.geolocation) {
      this.setStatus('Your browser can’t share its location. Try searching by city or ZIP code.');
      return;
    }
    var id = ++this.searchId;
    this.geoButton.disabled = true;
    this.setStatus('Finding your location…');
    navigator.geolocation.getCurrentPosition(function (position) {
      self.geoButton.disabled = false;
      if (id !== self.searchId) return;
      self.input.value = '';
      self.syncUrl();
      self.markState(null);
      self.showNear({ lat: position.coords.latitude, lng: position.coords.longitude, label: 'your location' });
    }, function () {
      self.geoButton.disabled = false;
      if (id !== self.searchId) return;
      self.setStatus('We couldn’t get your location. Check your browser’s location permission, or search by city or ZIP code.');
    }, { enableHighAccuracy: false, timeout: 10000, maximumAge: 600000 });
  };

  Locator.prototype.syncUrl = function () {
    if (!window.history.replaceState) return;
    var params = new URLSearchParams(window.location.search);
    var query = this.input.value.trim();
    if (query) params.set('q', query); else params.delete('q');
    params.set('radius', this.radius());
    params.delete('addressInput');
    var search = params.toString();
    window.history.replaceState(null, '', window.location.pathname + (search ? '?' + search : '') + window.location.hash);
  };

  function byCityThenName(a, b) {
    return a.state.localeCompare(b.state) || a.city.localeCompare(b.city) || a.name.localeCompare(b.name);
  }

  function plural(count, word) {
    return count === 1 ? word : word + 's';
  }

  function formatDistance(miles) {
    return (miles < 10 ? miles.toFixed(1) : Math.round(miles)) + ' mi';
  }

  function init() {
    document.querySelectorAll('[data-store-locator]').forEach(function (root) {
      if (root.storeLocator) return;
      root.storeLocator = new Locator(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
